/* tslint:disable */
/* eslint-disable */
export enum PaymentType {
  Monthly = 'MONTHLY',
  End = 'END'
}
